import { BrowserRouter as Router } from "react-router-dom";
import MainApp from "./Main";

function App() {
  return (
    <Router>
      <MainApp />
    </Router>
  );
}

export default App;
